import Enumeration from './enum';

const loandolphinHref = process.env.VUE_APP_LOANDOLPHIN_WEBSITE;
const blogHref = process.env.VUE_APP_LOANDOLPHIN_BLOG;
const customerHref = process.env.VUE_APP_CUSTOMER_DASHBOARD;

const RouteEnum = new Enumeration({
  HOME: routeType('/:company?', 'home', 'Home'),
  LOGIN: routeType('/login', 'login', 'Login'),
  NOT_FOUND: routeType('/404', '404', 'Not Found'),
});

const ExternalEnum = new Enumeration({
  HOME: externalType(loandolphinHref, 'home', 'loandolphin.com.au'),
  BLOG: externalType(blogHref, 'blog', 'Blog'),
  ABOUT: externalType(`${loandolphinHref}#about-us`, 'about_us', 'About us'),
  CALCULATORS: externalType(`${blogHref}/calculators`, 'calculators', 'Calculators'),
  CONTACT: externalType(`${loandolphinHref}#contact-us`, 'contact', 'Contact us'),
  PARTNERS: externalType(`${loandolphinHref}/partners`, 'partners', 'Partner with us'),
  TERMS: externalType(`${loandolphinHref}/terms-and-conditions`, 'terms', 'Terms and conditions'),
  PRIVACY: externalType(`${loandolphinHref}/privacy-policy`, 'privacy-policy', 'Privacy policy'),
  LOGIN: externalType(`${customerHref}/login`, 'login', 'Login'),
  FAQS: externalType(`${blogHref}/frequently-asked-questions`, 'faqs', 'FAQs'),
  CONCIERGE: externalType(`${loandolphinHref}/concierge`, 'concierge', 'Concierge'),
});

const SocialEnum = new Enumeration({
  TWITTER: externalType('https://twitter.com/LoanDolphinAU/', 'twitter', 'Twitter'),
  FACEBOOK: externalType('https://www.facebook.com/loandolphin.au/', 'facebook', 'Facebook'),
  LINKEDIN: externalType('https://www.linkedin.com/company/loandolphin/', 'linkedin', 'Linkedin'),
  YOUTUBE: externalType('https://www.youtube.com/channel/UCTdT976ytrcQctGf85m1D_A/', 'youtube', 'Youtube'),
});

const ReviewEnum = new Enumeration([
  externalType('https://www.productreview.com.au/reviews/7fae5c50-b843-4092-8f67-33111494ed6e', 'review1', 'Review1'),
  externalType('https://www.productreview.com.au/reviews/790bcc4f-530b-454e-9eb4-7e5ce91ffbe3', 'review2', 'Review2'),
  externalType('https://www.productreview.com.au/reviews/5349f18a-36ac-4841-a745-3e6149bc77b9', 'review3', 'Review3'),
  externalType('https://www.productreview.com.au/reviews/f440e14f-1893-407a-8ddc-d10fbd74407f', 'review4', 'Review4'),
  externalType('https://www.productreview.com.au/reviews/3844e91b-73c7-356b-a325-cea39925ae1d', 'review5', 'Review5'),
  externalType('https://www.productreview.com.au/reviews/74995798-8334-31e4-bf22-58b2693b965f', 'review6', 'Review6'),
  externalType('https://www.productreview.com.au/reviews/5cdbe2f6-17dd-37c7-bfaa-2cdb2693179f', 'review7', 'Review7'),
]);

function routeType(path, name, title) {
  return { path, name, title };
}
function externalType(href, key, value) {
  return { href, key, value, target: '_blank' };
}

export function updateRouteTitles(translator) {
  RouteEnum.forEach((route) => {
    route.title = translator.t(`common.route.${route.name}`);
  });

  RouteEnum.forEach((route) => {
    route.value = translator.t(`common.external_route.${route.key}`);
  });
}

export default RouteEnum;
export { ExternalEnum, SocialEnum, ReviewEnum };
